import * as React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Text, Image, View, Link } from "@react-pdf/renderer";
import websiteImage from "../../../assets/pdf-export/web.png";
import instaSocialImage from "../../../assets/pdf-export/insta.png";
import tdcSocialImage from "../../../assets/pdf-export/tdc-social.png";
import { styles, wideStyles } from "./styles";
import { ISinglePro } from "../../../components/singlePro/state";
import { ProExportContext } from "./helper";
import { cldUrl } from "../../../utils/cloudinary";

interface Props {
  pro: ISinglePro;
}


export const SinglePro: React.FC<Props> = ({ pro }) => {
  const { wide } = React.useContext(ProExportContext);

  const getSocialLink = (image?: any, link?: string | null) => {
    if (!link || !image) return null;
    return (
      <Link src={link}>
        <Image source={image} style={{ maxHeight: "13px" }} />
      </Link>
    );
  };

  const profileLink = React.useMemo(
    () =>
      `https://portal.thedesirecompany.com/experts/${pro.userid}/${
        pro.slug || "-"
      }`,
    [pro]
  );

  const getSlicedDescription = () => {
    let text = pro.short_description;
    if (!text) text = pro.description || "";

    const maxDescriptionLength = wide ? 350 : 230;

    if (text.length > maxDescriptionLength)
      return `${text.slice(0, maxDescriptionLength)}...`;
    return text;
  };

  const getStyles = (key: string) => {
    if (!wide) return styles[key];
    return { ...styles[key], ...wideStyles[key] };
  };

  return (
    <View key={pro.userid} style={getStyles("pro")}>
      <View style={styles.proTopWrapper}>
        <View style={getStyles("proAvatarWrapper")}>
          {pro.avatar && (
            <Image source={cldUrl(pro.avatar, { w: 100, h: 100, crop: "fill", gravity: "face" })} style={getStyles( "proAvatar" )} />
          )}

          {!pro.avatar && (
            <View style={ { width: '50px', height: '50px', borderRadius: '50%', backgroundColor: '#a5a5a5', border: '1px solid black' } } />
          )}
        </View>
        <View style={styles.proDeets}>
          <Text style={styles.proName}>{pro.displayName}</Text>
          {!!pro.professions?.length && (
            <Text style={getStyles("proProfession")}>
              {pro.professions
                ?.map((profession) => profession.profession)
                .join(" | ")}
            </Text>
          )}
          <View style={getStyles("proSocial")}>
            {getSocialLink(websiteImage, pro.website)}
            {getSocialLink(instaSocialImage, pro.instagram)}
            {getSocialLink(tdcSocialImage, profileLink)}
          </View>
        </View>
      </View>
      <View style={styles.proBio}>
        {!!pro.keyPoints?.length && (
          <View style={{ flexDirection: "column" }}>
            {pro.keyPoints.map((point, index) => (
              <View style={{ flexDirection: "row", marginBottom: 4 }} key={ index }>
                <Text style={{ marginHorizontal: 8 }}>•</Text>
                <Text>{point.keyPoint}</Text>
              </View>
            ))}
          </View>
        )}
        {!pro.keyPoints?.length && <Text>{getSlicedDescription()}</Text>}
      </View>
    </View>
  );
};
